import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@ion/env';
import { ModalContext } from '@ion/notifications';
import { SafePipe } from '@ion/pipes';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

export type IonLegalDocsModalOpts = { documentName: string; language: string };

@Component({
  selector: 'ion-legal-documents',
  imports: [SafePipe, CommonModule, TranslateModule],
  templateUrl: './legal-documents.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './legal-documents.component.scss',
})
export class LegalDocumentsComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly baseUrl = environment.legalDocsBaseUrl;
  private readonly translateService = inject(TranslateService);
  readonly destroyRef = inject(DestroyRef);
  readonly context = inject<ModalContext<IonLegalDocsModalOpts, string>>(POLYMORPHEUS_CONTEXT, { optional: true });
  readonly isModal = computed(() => !!this.context?.data);
  currentUrl = '';

  ngOnInit(): void {
    if (this.isModal()) {
      this.currentUrl = `${this.baseUrl}${this.context?.data.documentName}-${this.context?.data.language}.html`;
    } else {
      this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
        const documentName = params.get('documentName') || 'imprint';
        const lang = this.translateService.getCurrentLang().split('-')[0];
        this.currentUrl = `${this.baseUrl}${documentName}-${lang}.html`;
      });
    }
  }
}
